import Vue from "vue";
import Router from "vue-router";
import Page from "@/components/Page";
import Article from "@/components/Article";

Vue.use(Router);

export default new Router({
  mode: "history",
  linkActiveClass: "router-link-active",
  routes: [
    {
      path: "/artikel/:slug",
      name: "page",
      component: Article
    },
    {
      path: "/*",
      name: "page",
      component: Page
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js